import * as React from 'react';
import mergeRefs from 'react-merge-refs';
import Notification from '../shared/notification';
import IconCheckmarkCircle from '../icons/icon_checkmark_circle';
import IconHelp from '../icons/icon_help';
import IconInfo from '../icons/icon_info';
import IconWarningAlt from '../icons/icon_warning_alt';
import IconXCircle from '../icons/icon_x_circle';
import useStyles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var inlineIcon = {
  help: IconHelp,
  informative: IconInfo,
  negative: IconXCircle,
  positive: IconCheckmarkCircle,
  warning: IconWarningAlt
};
var InlineNotification = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    action,
    description,
    hideIcon = false,
    i18n,
    id,
    onClose,
    closeButton = true,
    title,
    type = 'informative'
  } = _ref;
  var inlineRef = React.useRef();
  var style = useStyles({
    type
  });
  var Icon = type && inlineIcon[type];
  var themedIcon = type && ___EmotionJSX(Icon, {
    "aria-hidden": true,
    css: style.icon,
    filled: true
  });
  return ___EmotionJSX(Notification, {
    action: action,
    description: description,
    closeButton: closeButton,
    hideIcon: hideIcon,
    i18n: i18n,
    icon: themedIcon,
    id: id,
    onClose: onClose,
    ref: mergeRefs([ref, inlineRef]),
    style: style.root,
    title: title,
    type: type
  });
});
InlineNotification.displayName = 'InlineNotification';
export default InlineNotification;